import * as React from 'react';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ScheduleIcon from '@mui/icons-material/Schedule';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import { useRecordContext, useTranslate } from 'react-admin';

interface CampaignStatusRecord {
    status: number;
    start_date: string;
    end_date: string;
}

export const getCampaignState = (record: CampaignStatusRecord, now = Date.now()) => {
    const start = Date.parse(record.start_date);
    const end = Date.parse(record.end_date);
    if (![0, 1].includes(record.status) || !Number.isFinite(start) ||
        !Number.isFinite(end) || end < start) {
        throw new Error('Invalid campaign status or date range');
    }
    if (record.status === 1) return 'inactive';
    if (now < start) return 'upcoming';
    if (now > end) return 'ended';
    return 'ongoing';
};

const states = {
    ongoing: { color: 'success', icon: <CheckCircleIcon /> },
    upcoming: { color: 'info', icon: <ScheduleIcon /> },
    ended: { color: 'default', icon: <EventBusyIcon /> },
    inactive: { color: 'warning', icon: <PauseCircleIcon /> },
} as const;

const CampaignStatusField = (_props: { source: string; sortable?: boolean }) => {
    const record = useRecordContext<CampaignStatusRecord>();
    const translate = useTranslate();
    const [now, setNow] = React.useState(Date.now);
    React.useEffect(() => {
        const timer = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(timer);
    }, []);
    if (!record) return null;
    const state = getCampaignState(record, now);
    return (
        <Chip
            size="small"
            color={states[state].color}
            icon={states[state].icon}
            label={translate(`resources.campaign.filters.${state}`)}
        />
    );
};

export default CampaignStatusField;
